// Whether a sticky element is stuck: its top has reached the sticky bar above it. Used by the
// Record header to show its line only while the page has scrolled under it. A callback ref, so it
// also works when the element appears after the first render.
import { useEffect, useState } from 'react';

export function useStuck() {
  const [el, ref] = useState<HTMLElement | null>(null);
  const [stuck, setStuck] = useState(false);
  useEffect(() => {
    if (!el) return;
    // The bar above is var(--topbar-h) tall; read it so the kit token stays the one source.
    const bar = parseFloat(getComputedStyle(el).getPropertyValue('--topbar-h')) || 0;
    const check = () => setStuck(window.scrollY > 0 && el.getBoundingClientRect().top <= bar + 1);
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [el]);
  return { ref, stuck };
}
